<ng-template #content>
  <ng-content></ng-content>
</ng-template>

<div (click)="executeInteraction()">
  <ng-content></ng-content>
</div>